import comp from "./SectionHeader";
export default comp;
